import { useEffect } from 'react'

export default function PrivacyPolicy() {
	useEffect(() => {
		const script = document.createElement('script')
		script.id = 'termly-jssdk'
		script.src = 'https://app.termly.io/embed-policy.min.js'

		const targetElement = document.getElementsByTagName('script')[0]
		if (!document.getElementById('termly-jssdk')) {
			targetElement.parentNode.insertBefore(script, targetElement)
		}

		return () => {
			// Clean up the script if necessary
			if (document.getElementById('termly-jssdk')) {
				document.getElementById('termly-jssdk').remove()
			}
		}
	}, [])

	return (
		<div className="mx-auto max-w-[1440px] px-4 py-16 md:px-12 lg:px-28">
			<div name="termly-embed" data-id="5842f284-ae19-4799-b5e3-6256db3dd09c" />
		</div>
	)
}
